module.exports = __webpack_public_path__ + "img/logo-light.d2388103.svg";